import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import './ValidInput.css';

var ValidInput = /*#__PURE__*/function (_Component) {
  _inherits(ValidInput, _Component);

  var _super = _createSuper(ValidInput);

  function ValidInput() {
    var _this;

    _classCallCheck(this, ValidInput);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "onChange", function (e) {
      _this.changed = true;

      if (_this.props.onChange) {
        var v = e.target.value;

        var r = _this.props.validator(_this.changed, v);

        _this.props.onChange(v, r.isError);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderError", function () {
      try {
        var r = _this.props.validator(_this.changed, _this.props.value, 'g');

        if (!r.isError) {
          return null;
        }

        return /*#__PURE__*/React.createElement("div", {
          className: "validErr"
        }, r.msg);
      } catch (error) {
        console.warn('render valid error fail', error);
        return /*#__PURE__*/React.createElement("div", {
          className: "validErr"
        }, 'valid error');
      }
    });

    return _this;
  }

  _createClass(ValidInput, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          inputClassName = _this$props.inputClassName,
          inputType = _this$props.inputType,
          isInputReadOnly = _this$props.isInputReadOnly;
      inputType = inputType || 'text';
      var errTip = this.renderError();
      return /*#__PURE__*/React.createElement("div", {
        id: "valid-input",
        className: "validInput ".concat(this.props.className || ''),
        style: this.props.style
      }, /*#__PURE__*/React.createElement("input", {
        className: "".concat(errTip && 'innerError', " ").concat(inputClassName),
        type: inputType,
        value: this.props.value,
        onChange: this.onChange,
        readOnly: isInputReadOnly
      }), errTip);
    }
  }]);

  return ValidInput;
}(Component);

ValidInput.propTypes = {
  className: PropTypes.string,
  inputClassName: PropTypes.string,
  inputType: PropTypes.string,
  validator: PropTypes.func,
  value: PropTypes.string,
  onChange: PropTypes.func,
  style: PropTypes.object,
  isInputReadOnly: PropTypes.bool
};
export default ValidInput;
export var ValidControl = /*#__PURE__*/function (_Component2) {
  _inherits(ValidControl, _Component2);

  var _super2 = _createSuper(ValidControl);

  function ValidControl() {
    var _this2;

    _classCallCheck(this, ValidControl);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this2 = _super2.call.apply(_super2, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this2), "state", {
      isInvalid: {},
      isInit: true
    });

    _defineProperty(_assertThisInitialized(_this2), "changeIsInvalid", function (key, isInvalid) {
      _this2.setState(function (prevS) {
        var i = _objectSpread({}, prevS.isInvalid);

        if (!isInvalid) {
          delete i[key];
        } else {
          i[key] = isInvalid;
        }

        return {
          isInvalid: i
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this2), "handleInvalid", function (key, toBeInvalid) {
      if (_this2.state.isInit) {
        _this2.setState({
          isInit: false
        });
      }

      var isInvalid = _.get(_this2.state, "isInvalid.".concat(key));

      if (!isInvalid) {
        if (toBeInvalid) {
          _this2.changeIsInvalid(key, true);
        }
      } else {
        if (!toBeInvalid) {
          _this2.changeIsInvalid(key, false);
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this2), "isFormValid", function (isInvalidObj) {
      var _i = isInvalidObj || _this2.state.isInvalid;

      return Object.keys(_i).map(function (k) {
        return _i[k];
      }).filter(function (it) {
        return it;
      }).length == 0;
    });

    return _this2;
  }

  _createClass(ValidControl, [{
    key: "render",
    value: function render() {
      var _this$state = this.state,
          isInvalid = _this$state.isInvalid,
          isInit = _this$state.isInit;
      return this.props.render({
        isInvalidSet: isInvalid,
        handleInvalid: this.handleInvalid,
        isFormValid: this.isFormValid(),
        isInit: isInit
      });
    }
  }]);

  return ValidControl;
}(Component);
ValidControl.propTypes = {
  render: PropTypes.func.isRequired
};